<script setup>
import { computed } from "vue";

const props = defineProps({
    type: {
        type: String,
        default: 'info',
    },
})

const colorClasses = computed(function() {
    if(props.type == 'info') {
        return 'bg-Blue-50 border-Blue-100 text-Blue-400';
        // Disabled buttons should be used for disabled actions of any colour button.
    }

    if(props.type == 'disabled') {
        return 'bg-gray-50 border-gray-100 text-gray-400';
        // Disabled buttons should be used for disabled actions of any colour button.
    }

    if(props.type == 'success') {
        return 'bg-Green-50 border-Green-200 text-Green-500';
        // Green buttons should be used for booking actions.
    }

    if(props.type == 'danger') {
        return 'bg-Red-50 border-Red-200 text-Red-500';
        // Blue buttons should be used for non-booking actions.
    }

    if(props.type == 'warning') {
        return 'bg-Yellow-100 border-Yellow-600 text-Yellow-700';
        // Yellow buttons should be used for ____ actions.
    }

    if(props.type == 'caution') {
        return 'bg-Orange-100 border-Orange-300 text-Orange-700';
        // Yellow buttons should be used for ____ actions.
    }
});
</script>

<template>
    <div 
        class="rounded-md border shadow-sm w-full my-2"
        :class="colorClasses"
    >
        <div class="py-3 px-4 w-full h-full">
            <slot />
        </div>
    </div>
</template>